var $45612f2e11248af8$exports = {};
$45612f2e11248af8$exports = {
    "loading": `A carregar...`,
    "loadingMore": `A carregar mais...`
};


export {$45612f2e11248af8$exports as default};
//# sourceMappingURL=pt-PT.mjs.map
